import { GAMES } from "@/data/site";

export default function GamesBento() {
  return (
    <div data-testid="games-bento" className="games-grid">
      {GAMES.map((g) => (
        <div
          key={g.slug}
          data-testid={`game-tile-${g.slug}`}
          className={`game-tile hover-glow group relative rounded-xl border bg-gradient-to-br from-[#141414] to-[#0A0A0A] overflow-hidden flex flex-col items-center justify-center gap-2 p-3 ${
            g.featured
              ? "border-rgv-red shadow-[0_0_20px_rgba(208,33,41,0.35)] lg:col-span-2 lg:row-span-2"
              : "border-rgv-maroon"
          }`}
        >
          {g.featured && (
            <span className="absolute top-2 left-2 z-10 bg-rgv-red text-white text-[10px] font-display uppercase px-2 py-0.5 rounded-sm tracking-wide whitespace-nowrap">
              Featured
            </span>
          )}
          <img
            src={g.icon}
            alt={g.name}
            loading="lazy"
            decoding="async"
            className="game-tile-icon object-contain transition-transform duration-300 group-hover:scale-110"
          />
          <span className="game-tile-label font-display uppercase text-center text-white/90 line-clamp-2">
            {g.name}
          </span>
        </div>
      ))}
    </div>
  );
}
